/**
 * AlmadarPostSoftwareThatSharesENPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostSoftwareThatSharesENPostPage
 */

import { useAlmadarPostSoftwareThatSharesENPostPageLogic } from '@/hooks/traits/useAlmadarPostSoftwareThatSharesENPostPageLogic';
import type { AlmadarPostSoftwareThatSharesENPostPageConfig } from '@/hooks/traits/useAlmadarPostSoftwareThatSharesENPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostSoftwareThatSharesENPostView as AlmadarPostSoftwareThatSharesENPostViewEntity } from '@app/shared';
import { Container } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { AlmadarPostSoftwareThatSharesENPostView } from '@/components/traits/AlmadarPostSoftwareThatSharesENPostView';
import { AlmadarPostSoftwareThatSharesENPostFooterView } from '@/components/traits/AlmadarPostSoftwareThatSharesENPostFooterView';
import { AlmadarPostSoftwareThatSharesENPostHeaderView } from '@/components/traits/AlmadarPostSoftwareThatSharesENPostHeaderView';
import { Box } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostSoftwareThatSharesENPostPageViewProps {
  config?: Partial<AlmadarPostSoftwareThatSharesENPostPageConfig>;
}

export function AlmadarPostSoftwareThatSharesENPostPageView({ config: propsConfig }: AlmadarPostSoftwareThatSharesENPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostSoftwareThatSharesENPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostSoftwareThatSharesENPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostSoftwareThatSharesEN" trait="AlmadarPostSoftwareThatSharesENPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostSoftwareThatSharesENPostPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><AlmadarPostSoftwareThatSharesENPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box fullWidth={true} paddingY="xl" bg="transparent"><Container padding="lg" size="xl" maxWidth="xl"><AlmadarPostSoftwareThatSharesENPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostSoftwareThatSharesENPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostSoftwareThatSharesENPostPageView;
